import React from 'react';
import authService from '../../../services/authService';

let posTypesCache: string[] | null = null;

export const useStoreDetailsPosTypes = (shouldLoad: boolean) => {
    const [posTypes, setPosTypes] = React.useState<string[]>(posTypesCache ?? []);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        if (!shouldLoad || posTypesCache) {
            if (posTypesCache && posTypes.length === 0) {
                setPosTypes(posTypesCache);
            }
            return;
        }

        let mounted = true;

        const loadPosTypes = async () => {
            try {
                setLoading(true);
                const response = await authService.getPosTypes();
                const nextPosTypes = Array.isArray(response) ? response : [];
                posTypesCache = nextPosTypes;
                if (mounted) {
                    setPosTypes(nextPosTypes);
                }
            } catch (error) {
                console.error('Failed to load POS types:', error);
                if (mounted) {
                    setPosTypes([]);
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        void loadPosTypes();

        return () => {
            mounted = false;
        };
    }, [posTypes.length, shouldLoad]);

    return {
        posTypes,
        posTypesLoading: loading,
    };
};
